import React, { FunctionComponent, useState } from 'react';
import { useParams } from 'react-router-dom';
import SaveIcon from '@mui/icons-material/Save';
import { Checkbox, IconButton, Stack, Typography } from '@mui/material';
import { TestDto } from '../../dto/TestDto';
import { IApiResult } from '../../interface/IApiResult';
import { apiSaveTest } from '../../service/apiSaveTest';
import { IAlertProps } from '../../interface/IAlertProps';
import { getDefaultAlertProps } from '../../utils/utils';
import { AlertSeverityEnum } from '../../enum/AlertSeverityEnum';
import { API_STATUS_PROBLEM } from '../../constant/constants';
import { MyAlert } from '../UI/MyAlert';
import { MyTextFiled } from '../UI/MyTextField';

interface Props {
  num: number;
  isEdit: boolean;
  keyTitle: string;
  titleName: string;
  dto?: TestDto;
  checked?: boolean;
  onSelect?: (checked: boolean) => void;
}

export const DialogTestItemToAdd: FunctionComponent<Props> = ({
  num,
  isEdit,
  keyTitle,
  titleName,
  dto,
  checked = false,
  onSelect,
}) => {
  const [alertProps, setAlertProps] = useState<IAlertProps>(
    getDefaultAlertProps()
  );

  const { section } = useParams();

  const [testDto, setTestDto] = useState(dto);

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onSelect) {
      onSelect(event.target.checked);
    }
  };

  return (
    <div>
      <MyAlert
        message={alertProps.message}
        severity={alertProps.severity}
        onClose={() => setAlertProps({ ...alertProps, message: '' })}
      />
      <Stack
        alignItems="center"
        direction="row"
        justifyContent="center"
        spacing={1}
      >
        <Checkbox checked={checked} onChange={handleCheckboxChange} />
        <Typography
          style={{
            fontFamily: 'sans-serif',
            fontStyle: 'normal',
            fontWeight: 500,
            width: '100%',
            fontSize: '13px',
            color: '#000000',
            letterSpacing: 1,
          }}
          component="text"
        >
          <span style={{ fontWeight: 700 }}>Вопрос {num}.</span>
          {` ${testDto?.question}`}
        </Typography>
      </Stack>
    </div>
  );
};

DialogTestItemToAdd.defaultProps = {
  dto: undefined,
  checked: false,
  onSelect: undefined,
};
